module.exports = __webpack_public_path__ + "media/winner.acaa6ee8.mp3";